/*!
 * Strabella Funnel Tracker v1
 * - Captures utm_* params on first hit, persists 30 days
 * - Writes them to Shopify cart attributes (survive checkout → order)
 * - Mirrors funnel_id from <body data-funnel> set by the lp-funnel template
 * - Forwards funnel_view + custom events to GA4 / TikTok pixel / Pinterest tag if present
 * - Exposes window.SBFunnel for Mailchimp form hydration
 *
 * Safe to load on every page; no-ops when no UTM + no funnel binding.
 */
(function () {
  'use strict';

  var UTM_KEYS = ['utm_source','utm_medium','utm_campaign','utm_content','utm_term'];
  var STORE_PREFIX = 'sb_utm_';
  var TTL_MS = 30 * 24 * 60 * 60 * 1000; // 30 days

  function safeGetLS(k){
    try { return window.localStorage.getItem(k); } catch (e) { return null; }
  }
  function safeSetLS(k, v){
    try { window.localStorage.setItem(k, v); } catch (e) {}
  }

  // 1) Capture from current URL
  var captured = {};
  try {
    var url = new URL(window.location.href);
    UTM_KEYS.forEach(function(k){
      var v = url.searchParams.get(k);
      if (v) {
        captured[k] = v;
        safeSetLS(STORE_PREFIX + k, JSON.stringify({ v: v, ts: Date.now() }));
      }
    });
  } catch (e) {}

  // 2) Hydrate any missing keys from localStorage
  var utm = {};
  UTM_KEYS.forEach(function(k){
    if (captured[k]) { utm[k] = captured[k]; return; }
    var raw = safeGetLS(STORE_PREFIX + k);
    if (!raw) return;
    try {
      var o = JSON.parse(raw);
      if (o && o.v && (Date.now() - (o.ts || 0)) < TTL_MS) utm[k] = o.v;
    } catch (e) {}
  });

  // 3) Body-driven funnel context
  var body = document.body;
  var funnelId = (body && body.getAttribute && body.getAttribute('data-funnel')) || '';
  var funnelSrc = (body && body.getAttribute && body.getAttribute('data-funnel-source')) || '';
  var funnelCampaign = (body && body.getAttribute && body.getAttribute('data-funnel-campaign')) || '';

  // 4) Build the attribute payload that will ride into checkout
  var cartAttrPayload = {};
  UTM_KEYS.forEach(function(k){ if (utm[k]) cartAttrPayload[k] = utm[k]; });
  if (funnelId) cartAttrPayload.funnel_id = funnelId;
  if (funnelSrc && !cartAttrPayload.utm_source) cartAttrPayload.utm_source = funnelSrc;
  if (funnelCampaign && !cartAttrPayload.utm_campaign) cartAttrPayload.utm_campaign = funnelCampaign;

  // 5) Persist to Shopify cart attributes (idempotent, runs only if we have something)
  if (Object.keys(cartAttrPayload).length) {
    try {
      fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ attributes: cartAttrPayload })
      }).catch(function(){});
    } catch (e) {}
  }

  // 6) Forward funnel_view to whatever analytics are present
  var eventPayload = Object.assign({}, cartAttrPayload, {
    page_path: window.location.pathname,
    page_url: window.location.href
  });
  try { if (typeof window.gtag === 'function') window.gtag('event', 'funnel_view', eventPayload); } catch (e) {}
  try { if (typeof window.ttq !== 'undefined' && typeof window.ttq.track === 'function') window.ttq.track('ViewContent', eventPayload); } catch (e) {}
  try { if (typeof window.pintrk === 'function') window.pintrk('track', 'pagevisit', eventPayload); } catch (e) {}

  // 7) Public surface for lead-card + bundle CTA hydration
  window.SBFunnel = {
    version: '1.0.0',
    utm: utm,
    funnelId: funnelId,
    source: funnelSrc,
    campaign: funnelCampaign,
    cartAttrs: cartAttrPayload,
    trackEvent: function(name, props){
      var payload = Object.assign({}, cartAttrPayload, props || {});
      try { if (typeof window.gtag === 'function') window.gtag('event', name, payload); } catch (e) {}
      try { if (typeof window.ttq !== 'undefined' && typeof window.ttq.track === 'function') window.ttq.track(name, payload); } catch (e) {}
      try { if (typeof window.pintrk === 'function') window.pintrk('track', name, payload); } catch (e) {}
      try { window.dispatchEvent(new CustomEvent('sb:funnel:event', { detail: { name: name, payload: payload } })); } catch (e) {}
    }
  };

  // 8) Auto-track lead-form submits + bundle-CTA clicks (graceful if not present)
  document.addEventListener('submit', function(ev){
    var f = ev.target;
    if (f && f.action && /list-manage\.com\/subscribe/.test(f.action)) {
      window.SBFunnel.trackEvent('lead_capture', { form_id: f.id || '', mc_source_tag: (f.querySelector('input[name="MMERGE6"]')||{}).value || '' });
    }
  }, true);
  document.addEventListener('click', function(ev){
    var t = ev.target;
    while (t && t !== document) {
      if (t.classList && (t.classList.contains('lp-cta') || t.classList.contains('lp-bundle-add'))) {
        window.SBFunnel.trackEvent('cta_click', { cta_label: t.textContent.trim().slice(0,80), cta_href: t.getAttribute('href')||'' });
        break;
      }
      t = t.parentNode;
    }
  }, true);
})();
